import { Profile } from 'flow/types/Profile';
import { TypedMap } from 'flow/types/TypedMap';
import { hasSpokenReferralActiveOnProfile } from 'flow/utils/profile-utils';

/**
 * Reads what happens to a call to the fixed number after the referral
 * sound. The order is the one the admin portal uses: the refer action
 * first, then the unconditional redirect, then the parallel call type.
 * The admin portal keeps the redirect when it sets a refer action, so a
 * profile can hold both. Hang up applies with or without a sound. Repeat
 * sound needs a sound, so without one it is skipped, as getReferralOptions
 * skips it.
 */
const getReferralType = (profile: TypedMap<Profile>): string => {
    const referAction = profile.getIn([
        'spokenNotification',
        'referActionType',
    ]);
    const hasSound = hasSpokenReferralActiveOnProfile(profile);

    if (referAction === 'hangup' || (referAction === 'loop' && hasSound)) {
        return referAction;
    }

    const redirectType = profile.getIn([
        'callForwarding',
        'unconditionalRedirect',
        'type',
    ]);

    if (redirectType === 'voicemail' || redirectType === 'sharedvoicemail') {
        return 'voicemail';
    }

    if (redirectType === 'number') {
        return 'number';
    }

    return profile.getIn(['parallelCalls', 'parallelCallType']);
};

export default getReferralType;
